import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import $ from 'jquery';
import { connect } from 'react-redux';
import { setCouponStatus } from 'MyAccount/ViewDesigns/redux/modules/upgrade';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import IconButton from 'material-ui/IconButton';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import { grey50 } from 'material-ui/styles/colors';
import getCouponType, { couponTypes } from '../helpers/getCouponType';

const sassStyles = require('./styles.scss');
const styles = {
  textField: {
    margin: 0,
  },
  btn: {
    padding: '5px 2px',
  },
};


@connect(
  state => ({
    couponStatus: state.upgrade.couponStatus ? state.upgrade.couponStatus : {}
  }),
  { setCouponStatus }
)
class CouponBox extends React.Component {
  state = {
    code: this.props.couponStatus.code ? this.props.couponStatus.code : '',
    loading: false,
    coupon: null,
    error: this.props.couponStatus.error ? this.props.couponStatus.error : '',
  };

  getText = () => {
    const {loading, error} = this.state;
    const coupon = this.props.couponStatus.coupon;
    if (error) {
      return error;
    }

    if (loading) {
      return 'Validating coupon...';
    }

    switch (getCouponType(coupon)) {
      case couponTypes.LIFETIME:
        return `Get a ${coupon.discountPercent}% LIFETIME discount - applied to the pricing plans below.`;
      case couponTypes.FREE_MONTHS:
        return `Get the first ${coupon.durationInMonth} months for FREE - applied to the pricing plans below.`;
      case couponTypes.DISCOUNT_MONTHS:
        return `Get a ${coupon.discountPercent}% discount for the FIRST ${coupon.durationInMonth} months - applied` +
        ' to the pricing plans below.';
      default:
        return 'Once you paste a code it will be applied to the table below';
    }
  };

  sendRequest = _.debounce(() => {
    const couponCode = this.state.code;
    if (couponCode && couponCode.trim().length > 0) {
      $.ajax({
        method: 'GET',
        url: '/application/user/get-coupon-status?promotion=' + encodeURIComponent(couponCode)
      }).fail(console.error.bind(console, 'checkCoupon'))
        .then((result) => {
          this.setState({
            error: result.error ? result.error : '',
            coupon: result.coupon,
            loading: false,
          }, () => this.props.setCouponStatus(result));
        });
    } else {
      this.setState({ error: '', coupon: null, loading: true }, () => this.props.setCouponStatus({ status: 'empty'}));
    }
  }, 1000, { trailing: true });

  handleChange = (value) => {
    this.setState({ code: value, error: '', loading: !_.isEmpty(value), }, !_.isEmpty(value) ? this.sendRequest() : null);
  };

  render() {
    const { error, code } = this.state;
    const { className, style } = this.props;

    return (
      <Paper className={`${sassStyles.coupon} ${className ? className : ''}`} style={{ backgroundColor: grey50 }}>
        <p className={sassStyles.header}>You got a promotion code?! Lucky you!</p>
        <div className={sassStyles.fields}>
          <div className={sassStyles.dotBox}>
            <TextField
              floatingLabelText="Promotion code"
              style={styles.textField}
              className={sassStyles.input}
              value={code}
              onChange={(e, value) => this.handleChange(value)}
              fullWidth
            />
            <div className={sassStyles.button}>
              <IconButton
                onClick={() => this.handleChange('')}
                tooltip="Clear"
                disabled={code.length === 0}
              >
                <CloseIcon/>
              </IconButton>
            </div>
          </div>
        </div>
        <p className={`${sassStyles.info} ${error ? sassStyles.err : ''}`}>
          {this.getText()}
        </p>
      </Paper>
    );
  }
}

CouponBox.propsTypes = {
  defaultValue: PropTypes.string,
  setCouponStatus: PropTypes.func,
};

CouponBox.defaulProps = {
  defaultValue: '',
  setCouponStatus: () => {},
};

export default CouponBox;